import {createSlice, PayloadAction, createAsyncThunk} from "@reduxjs/toolkit";
import * as T from "utils/types";
import * as API from 'app/public_api';

export const cntPerPage = 10;

const initList = createAsyncThunk(
    'profilePg/SmtPubTab/initList', 
    async (
        data:{
            randomID: string,
        }, 
        thunkAPI
    )=>{
        const {
            randomID
        } = data;
        const {currentPage}= (thunkAPI.getState() as T.RootState).profilePg_smtPubTab;
        return await API.rSmtPubList_oneRsr(
            randomID,
            currentPage+1,
        );
    }
)
const loadMore = createAsyncThunk(
    'profilePg/SmtPubTab/rSmtPubList', 
    async ( data:{randomID: string}, thunkAPI
    )=>{
        const {
            currentPage
        }= (thunkAPI.getState() as T.RootState).profilePg_smtPubTab;
        return await API.rSmtPubList_oneRsr(
            data.randomID,
            currentPage+1,
        );
    }
)

export const profilePg_smtPubTab_Thunks = {initList, loadMore,};

export const initialState: T.ProfilePg_SmtPubTab = {
    total: -1,
    smtPubList: [],
    currentPage: 0,
    hasNext: true,
    status: 'idle',
    errorMsg: null,
}

// profilePg_smtPubTab_S
export default createSlice({
    name: 'profilePg/SmtPubTab',
    initialState,
    reducers: {
    },
    extraReducers: builder=>{

        // initList thunk (this maybe called by other component, so it has this init steps)
        builder.addCase(initList.pending, (state, action) => {

            state.currentPage = initialState.currentPage;
            state.errorMsg = initialState.errorMsg;
            state.hasNext = initialState.hasNext;
            state.status = 'loading';

            // set the list to be cntPerPage skeleton items
            state.smtPubList = [
                ...new Array(cntPerPage)
            ].map(()=>({loading: true, item: null}));
        });
        builder.addCase(initList.fulfilled, (state, action) => {
            state.status = 'succeeded';

            const {links, total_result, results} = action.payload            

            state.total = total_result;
            state.hasNext = !!links.next;
            state.currentPage += 1;

            // set the list to what we received
            state.smtPubList = results.map(
                x=>({loading:false, item: x})
            );
        });
        builder.addCase(initList.rejected, (state, action) => {
            state.status = 'failed';
            state.errorMsg = action.error.message;
        });

        // loadMore thunk
        builder.addCase(loadMore.pending, (state, action) => {
            state.status = 'loading';

            // add cntPerPage skeleton items to the list
            state.smtPubList = state.smtPubList.concat( 
                [...new Array(cntPerPage)].map(()=>({loading:true, item: null}))
            );
        });
        builder.addCase(loadMore.fulfilled, (state, action) => {
            state.status = 'succeeded';

            const {links, total_result, results} = action.payload            

            state.total = total_result;
            state.hasNext = !!links.next;
            state.currentPage += 1;

            // replace the last cntPerPage skeleton item list 
            // to the list we received
            state.smtPubList = state.smtPubList.slice(0, -cntPerPage).concat( 
                results.map(x=>({loading:false, item: x}))
            );
        });
        builder.addCase(loadMore.rejected, (state, action) => {
            state.status = 'failed';
            state.errorMsg = action.error.message;
        });
    }
});
